import { render, staticRenderFns } from "./FeesForSecurityMasterPage.vue?vue&type=template&id=0ed3036c&scoped=true&"
import script from "./FeesForSecurityMasterPage.vue?vue&type=script&lang=js&"
export * from "./FeesForSecurityMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForSecurityMasterPage.vue?vue&type=style&index=0&id=0ed3036c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed3036c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed3036c')) {
      api.createRecord('0ed3036c', component.options)
    } else {
      api.reload('0ed3036c', component.options)
    }
    module.hot.accept("./FeesForSecurityMasterPage.vue?vue&type=template&id=0ed3036c&scoped=true&", function () {
      api.rerender('0ed3036c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/feeMaster/feesForSecurityMaster/FeesForSecurityMasterPage.vue"
export default component.exports